import { useEffect, useCallback } from 'react';

interface UseScrollLoadProps {
  isLoading: boolean;
  onLoadMore: () => void;
  threshold?: number;
}

export const useScrollLoad = ({
  isLoading,
  onLoadMore,
  threshold = 200,
}: UseScrollLoadProps) => {
  const handleScroll = useCallback(() => {
    if (isLoading) return;

    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    const { scrollHeight } = document.documentElement;
    const clientHeight = window.innerHeight;

    if (scrollTop + clientHeight >= scrollHeight - threshold) {
      onLoadMore();
    }
  }, [isLoading, onLoadMore, threshold]);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);
};
